import { getClrGradient } from '@gto/helpers/colors'

// new
function getEveqeqrblColorList({ clr1 = '#000000', clr2 = '#000000', clr3 = '#000000' }) {
  const halfOf21 = [...Array(10).keys()]

  // clr1 = '#f03c3c'
  // clr2 = '#ffffd9'
  // clr3 = '#59d167'

  const startToMiddle = halfOf21.map((_, idx) => {
    const xaxis = idx * 0.1
    const rClr = getClrGradient({
      clr1,
      clr2,
      xaxis,
    })
    return rClr
  })

  const middleToEnd = halfOf21.map((_, idx) => {
    const xaxis = idx * 0.1 + 0.1
    // console.log(xaxis)
    const rClr = getClrGradient({
      clr1: clr2,
      clr2: clr3,
      xaxis,
    })
    return rClr
  })

  // 21 clrs
  const res = [...startToMiddle, clr2, ...middleToEnd]
  // console.log(res)
  // debugger
  return res
}

function setEveqeqrblColorList({ clr1 = '#00000', clr2 = '#00000', clr3 = '#00000' }) {
  const clrField = getEveqeqrblColorList({ clr1, clr2, clr3 })

  clrField.forEach((clr, idx) => {
    const clrIdx = idx * 5
    const cssVar = `--clr-eveqeqrbl${clrIdx}`
    document.documentElement.style.setProperty(cssVar, clr)
  })
}

// function addAlpha(color, opacity) {
//   const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)
//   return color + _opacity.toString(16).toUpperCase()
// }
function colorLuminance(hex, lum) {
  hex = String(hex).replace(/[^0-9a-f]/gi, '')
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
  }
  lum = lum || 0
  let rgb = '#'
  let c
  let i
  for (i = 0; i < 3; i++) {
    c = parseInt((hex || '').substr(i * 2, 2), 16)
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16)
    rgb += `00${c}`.substr(c.length)
  }
  return rgb
}

export {
  getClrGradient,
  getEveqeqrblColorList,
  setEveqeqrblColorList,
  // addAlpha,
  colorLuminance,
}
